import { render, staticRenderFns } from "./fccClassificacaoAlteracoes.vue?vue&type=template&id=6c0faf42"
import script from "./fccClassificacaoAlteracoes.vue?vue&type=script&lang=js"
export * from "./fccClassificacaoAlteracoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports